/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Shipping_Fee_Payer_CompanyInputs */

const vi_carrier_form_shipping_fee_payer_company = /** @type {(inputs: Carrier_Form_Shipping_Fee_Payer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shop trả cước`)
};

/**

* @param {Carrier_Form_Shipping_Fee_Payer_CompanyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_shipping_fee_payer_company = /** @type {((inputs?: Carrier_Form_Shipping_Fee_Payer_CompanyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Shipping_Fee_Payer_CompanyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_shipping_fee_payer_company(inputs)
});